// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"c7ba9c64","167":"b1021318","845":"fcc4bcd0","984":"210bf798","993":"23736560"}[chunkId] + ".chunk.js";
};